import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { UnstyledButton } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/pro-regular-svg-icons";
import { Button } from "@/components/button";
import { ActionDoneIndicator } from "../action-done-indicator";
import { useComposerStore } from "@/stores/composers";
import { useTaskDetailStore } from "@/stores/task-detail";
import { useActionCompletionStore } from "@/stores/action-completion";
import { useTaskActions } from "@/components/task-actions-provider";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
/** A single letter action row — opens the composer at the suggested template; marks done only after the letter is sent. */
export function LetterAction(_ref) {
  var _template$name, _template$name2, _template$created_by;
  var action = _ref.action,
    template = _ref.template,
    patientUid = _ref.patientUid,
    reminderId = _ref.reminderId,
    isDone = _ref.isDone,
    onDelete = _ref.onDelete;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var openComposer = useComposerStore(function (s) {
    return s.open;
  });
  var minimizeTaskDetail = useTaskDetailStore(function (s) {
    return s.minimize;
  });
  var setPendingCompletion = useActionCompletionStore(function (s) {
    return s.setPending;
  });
  var _useTaskActions = useTaskActions(),
    onGenerateCommunication = _useTaskActions.onGenerateCommunication;
  var payload = action.payload;
  var composerTitle = (_template$name = template === null || template === void 0 ? void 0 : template.name) !== null && _template$name !== void 0 ? _template$name : t("label.generate_letter", {
    defaultValue: "Generate letter"
  });
  var handleGenerate = function handleGenerate() {
    trackEvent(ANALYTICS_EVENTS.LETTER_ACTION_GENERATE, {
      actionId: action.id
    });
    if (onGenerateCommunication) {
      if (patientUid != null) {
        setPendingCompletion("letter", {
          patientUid: patientUid,
          reminderId: reminderId,
          actionId: action.id
        });
      }
      onGenerateCommunication(payload.id);
      return;
    }
    minimizeTaskDetail();
    openComposer({
      id: "letter-action-".concat(action.id),
      type: "letter",
      title: composerTitle,
      initialTemplateId: payload.id,
      lockTemplate: true,
      actionMeta: {
        reminderId: reminderId,
        actionId: action.id
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "rounded-sds-200 border px-4 py-3 flex items-center gap-3 ".concat(isDone ? "bg-sds-base-secondary border-transparent" : "bg-sds-base-default border-sds-base-default")
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-0.5 flex-1 min-w-0"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-style-body-small-strong truncate ".concat(isDone ? "line-through text-sds-base-secondary" : "text-sds-base-default")
  }, (_template$name2 = template === null || template === void 0 ? void 0 : template.name) !== null && _template$name2 !== void 0 ? _template$name2 : t("label.unknown_template", {
    defaultValue: "Letter"
  })), (template === null || template === void 0 || (_template$created_by = template.created_by) === null || _template$created_by === void 0 ? void 0 : _template$created_by.name) && /*#__PURE__*/React.createElement("span", {
    className: "text-style-body-small text-sds-base-secondary"
  }, template.created_by.name)), isDone ? /*#__PURE__*/React.createElement(ActionDoneIndicator, {
    label: t("status.generated", {
      defaultValue: "Generated"
    })
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    "data-testid": "letter-action-generate-".concat(action.id),
    intent: "brand",
    variant: "secondary",
    size: "sm",
    onClick: handleGenerate
  }, t("button.generate", {
    defaultValue: "Generate"
  })), /*#__PURE__*/React.createElement(UnstyledButton, {
    "data-testid": "letter-action-delete-".concat(action.id),
    "aria-label": t("button.delete", {
      defaultValue: "Delete"
    }),
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.LETTER_ACTION_DELETE, {
        actionId: action.id
      });
      onDelete(action.id);
    },
    className: "w-7 h-7 flex items-center justify-center rounded-sds-100 text-sds-base-secondary hover:bg-sds-urgent-tertiary hover:text-sds-urgent-default transition-colors flex-shrink-0"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faTrash,
    className: "w-3.5 h-3.5"
  }))));
}